import { render } from "./UserSheet.vue?vue&type=template&id=618ff422&scoped=true&ts=true"
import script from "./UserSheet.vue?vue&type=script&lang=ts"
export * from "./UserSheet.vue?vue&type=script&lang=ts"

import "./UserSheet.vue?vue&type=style&index=0&id=618ff422&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618ff422"]])

export default __exports__